import {
    BarekamColumns,
    OrdersTableColumn,
    WarehouseWorkerColumns
} from "../../../../../pages/orders/my/models/column-models";
import React, { useEffect, useMemo, useState } from "react";
import { OrdersResponseModel } from "../../../../../pages/shared/models/api/orders-response.model";
import ordersService from "../../../../../services/orders.service";
import { TableBody, TableHead, TableRow } from "@mui/material";
import {
    OrderListContainer,
    OrderTable,
    OrderTableCell,
    OrderTableRow
} from "../../../../../pages/orders/my/order-list/styled";
import BarekamText from "../../../../../pages/components/text";
import { Message, MessageSections } from "../../../../../pages/components/message/message";
import { RowCell } from "../../../../../pages/orders/my/order-list/cell/row-cell";
import BarekamPagination from "../../../../../pages/orders/my/pagination/barekam-pagination";
import { useAppSelector } from "../../../../../redux/store";
import { OrderModel } from "../../../../../pages/shared/models/order/order-item.model";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import NoOrders from "../../../../../pages/orders/my/no-orders";
import { GenericActionTypes } from "../../../../actions/action-types.enum";
import { ActionDialog } from "../../../../actions/dialogs/action-dialog";
import BarekamInput from "../../../../../pages/components/input";
import { OrderFilterModel } from "../../../../../pages/shared/models/order/order-filter.model";
import { CardContent, GapContainer } from "../../../../../pages/components/card/styled";
import { AdminToolPanel } from "../../../../../pages/orders/my/tool-panel/admin-tool-panel";
import { ManagementPageType } from "../../../management-data-container";
import { getMessage } from "../../../../../pages/shared/helper-functions";

const internalTrackingNumberColumn: OrdersTableColumn = { field: 'internalTrackingNumber', headerName: 'order_list_barekam_tracking', variant: BarekamColumns.barekamTrack };
const productTrackNumbersColumn: OrdersTableColumn = { field: 'products', headerName: 'order_list_tracking', variant: BarekamColumns.productTrackNumbers };
const nameColumn: OrdersTableColumn = { field: 'name', headerName: 'order_list_name', variant: BarekamColumns.text };
const statusColumn: OrdersTableColumn = { field: 'trackRecord', headerName: 'order_list_status', variant: BarekamColumns.trackStatus };
const weightColumn: OrdersTableColumn = { field: 'weight', headerName: 'order_list_weight', variant: BarekamColumns.weight }
const recipientColumn: OrdersTableColumn = { field: 'recipient', headerName: 'order_list_recipient', variant: BarekamColumns.recipient, };
const paymentStatusColumn: OrdersTableColumn = { field: 'paymentStatus', headerName: 'order_list_payment', variant: BarekamColumns.paymentStatus, };
const allOrdersActionsColumn: OrdersTableColumn = { field: '', headerName: 'order_list_actions', variant: WarehouseWorkerColumns.allOrdersActions, };
const warehouseColumn: OrdersTableColumn = { field: '', headerName: 'order_warehouse', variant: BarekamColumns.firstWarehouse };
const dateColumn: OrdersTableColumn = { field: 'date', headerName: 'order_created_date', variant: BarekamColumns.orderDate };

const columns = [
    internalTrackingNumberColumn,
    productTrackNumbersColumn,
    statusColumn,
    warehouseColumn,
    nameColumn,
    recipientColumn,
    weightColumn,
    paymentStatusColumn,
    dateColumn,
    allOrdersActionsColumn
]

const AllOrders = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [filter, setFilter] = useState<OrderFilterModel>({});
    const [textQuery, setTextQuery] = useState('');
    const [searchParams, setSearchParams] = useSearchParams();
    const currentPage = useMemo(() => searchParams.get('page') && searchParams.get('page') !== '0' ? parseInt(searchParams.get('page') || '0') - 1 : 0, [searchParams]);

    const [ordersData, setOrdersData] = useState({
        currentPage,
        orders: [],
        pageSize: 10,
        totalItems: 0,
    } as OrdersResponseModel);

    const [activeAction, setActiveAction] = useState<string>();
    const [activeRowOrders, setActiveRowOrders] = useState([] as OrderModel[]);
    const [searchTimeoutId, setSearchTimeoutId] = useState<any>();

    const { orderStateId } = { orderStateId: 1 } // useAppSelector(state => state.ordersReducer);

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        loadOrders(currentPage > 0 ? currentPage - 1 : 0);
        // setTextQuery(filter.textQuery || '');
    }, [filter, currentPage])

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const stringJsonFilter = location.search && queryParams ? queryParams.get('jsonFilter') : null;
        if (stringJsonFilter) {
            const paramFilter = JSON.parse(stringJsonFilter);

            if (paramFilter) {
                setFilter(paramFilter);
            }
        }
    }, [])

    function loadOrders(page: number) {
        ordersService.getAllOrders(filter, ordersData.pageSize, page)
            .then(response => {
                setOrdersData({ ...response, currentPage });
                setIsLoading(false);
            })
        // if (Object.keys(filter).length) {

        // } else {
        //     setOrdersData({
        //         currentPage,
        //         orders: [],
        //         pageSize: 10,
        //         totalItems: 0,
        //     } as OrdersResponseModel);

        //     setIsLoading(false);
        // }
    }

    function handlePageChange(event: unknown, newPage: number) {
        loadOrders(newPage - 1);
        const params = new URLSearchParams(searchParams.toString());
        params.set('page', `${newPage}`);
        setSearchParams(params, { replace: true });
    }

    function openAction(order: OrderModel) {
        const params = new URLSearchParams();
        if (Object.keys(filter).length > 0) {
            params.append('jsonFilter', JSON.stringify(filter));
            navigate(location.pathname + '?' + params.toString(), { replace: true });
        }

        navigate(`./order/${order.orderId}`);
    }

    function onRowAction(row: OrderModel, action: any) {
        switch (action) {
            case GenericActionTypes.SEE_STATUS_HISTORY:
                setActiveRowOrders([row]);
                setActiveAction(action);
                break;
            case GenericActionTypes.SET_DISCOUNT:
                setActiveRowOrders([row]);
                setActiveAction(action);
                break;
        }
    }

    function handleActionDialogClosed() {
        if (activeAction === GenericActionTypes.SET_DISCOUNT) {
            handlePageChange('', ordersData.currentPage + 1);
        }

        setActiveAction(undefined);
        setActiveRowOrders([]);
    }

    function setFilterWithQuery() {
        const filterClone = { ...filter };

        if (textQuery) {
            filterClone.textQuery = textQuery;
        } else {
            delete filterClone.textQuery;
        }

        setFilter(filterClone);
    }

    function onSearchQueryChange(query: string) {
        setTextQuery(query);
        clearTimeout(searchTimeoutId);

        const newTimeoutId = setTimeout(() => {
            setFilterWithQuery();
        }, 3000);

        setSearchTimeoutId(newTimeoutId);
    }

    function onSearchQueryKeyUp(key: string) {
        if (key === 'Enter') {
            clearTimeout(searchTimeoutId);

            setFilterWithQuery();
        }
    }

    if (ordersData?.orders?.length) {
        return (
            <>
                <AdminToolPanel filter={filter} setFilter={setFilter} type={ManagementPageType.ALL_ORDERS} />

                <OrderListContainer>
                    {ordersData.orders.length
                        ? <OrderTable width={'100%'}>
                            <OrderListTableHead />

                            <TableBody>
                                {ordersData.orders.map((order, index) => {
                                    return (
                                        <OrderTableRow
                                            hover
                                            tabIndex={index}
                                            key={`${index}-${order.orderId}`}>
                                            {columns.map((column, columnIndex) => {
                                                return (
                                                    <RowCell cellVariant={column.variant}
                                                        field={column.field}
                                                        row={order}
                                                        groups={[]}
                                                        isName={columnIndex === 0}
                                                        key={`${columnIndex}-${order.orderId}-${column.field}`}
                                                        clicked={openAction}
                                                        onAction={onRowAction}
                                                        payButtonClicked={() => void (0)}
                                                        isWarehouseWorker={true}
                                                    />
                                                )
                                            })}
                                        </OrderTableRow>
                                    );
                                })}
                            </TableBody>
                        </OrderTable>
                        : isLoading ? '' : <NoOrders />
                    }

                    {ordersData.totalItems > ordersData.pageSize
                        ? <BarekamPagination {...ordersData} onPageChange={handlePageChange} />
                        : <></>
                    }
                </OrderListContainer>

                <ActionDialog open={!!activeAction}
                    closePopup={() => handleActionDialogClosed()}
                    action={activeAction}
                    orderStateId={orderStateId}
                    predefinedOrders={activeRowOrders}
                    historyDialogProps={activeRowOrders[0]?.orderId ? { category: 'Order', categoryId: activeRowOrders[0].orderId } : undefined} />
            </>
        )
    } else {
        return (
            <SearchForOrders textQuery={textQuery} onSearchQueryChange={onSearchQueryChange} onSearchQueryKeyUp={onSearchQueryKeyUp} />
        )
    }
};

const OrderListTableHead = () => {
    return (
        <TableHead>
            <TableRow>
                {columns.map((column, index) => (
                    <OrderTableCell key={`${index}-${column.field}`}>
                        <BarekamText variant={'m'} align={index === columns.length - 1 ? 'right' : 'left'}>
                            <Message messageKey={column.headerName} sectionId={MessageSections.ORDERS} />
                        </BarekamText>
                    </OrderTableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

const SearchForOrders = ({ textQuery, onSearchQueryChange, onSearchQueryKeyUp }: { textQuery: string, onSearchQueryChange: (query: string) => void, onSearchQueryKeyUp: (key: string) => void }) => {
    const { messageCache, languageId } = useAppSelector(state => state.messagesReducer);

    return (
        <CardContent style={{ backgroundColor: '#FFF', minHeight: '50rem', justifyContent: 'center' }}>
            <GapContainer style={{ flexDirection: 'column' }}>
                <BarekamInput customInputVariant={'search'}
                    width={'30rem'}
                    value={textQuery || ''}
                    placeholder={getMessage('search', MessageSections.ORDERS, messageCache, languageId)}
                    onChange={(event) => onSearchQueryChange(event.target.value)}
                    onKeyUp={(event) => onSearchQueryKeyUp(event.key)} />

                <BarekamText variant={"m"}>
                    <Message messageKey={"order_search_hint"} sectionId={MessageSections.ORDERS} />
                </BarekamText>
            </GapContainer>
        </CardContent>
    )
}

export default AllOrders;
